import {CHANGE_SCORES_VIEW} from './types';

export const changeScoreView = (show) => dispatch => {
    localStorage.setItem('showScores', show);
    dispatch({
        type: CHANGE_SCORES_VIEW,
        payload: show
    })
};
